(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4932],{

/***/ 54906:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[...products]",
      function () {
        return __webpack_require__(54365);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v3_ProductAccordion; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/react-collapsible/dist/index.js
var dist = __webpack_require__(97893);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./public/icons/arrow-up.svg
var arrow_up = __webpack_require__(97274);
// EXTERNAL MODULE: ./public/icons/arrow-down.svg
var arrow_down = __webpack_require__(32873);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordion/ProductAccordion.view.js









const Accordion = (props)=>{
    const { isOpen =false , contentOverflow =false , trigger =false , handleOpen , handleClose , containerElementProps , isArrow =false , items , itemsOrder , id , titleKey , componentPosition , componentLinkType , accordionProperties: { expandedItems =[]  } = {}  } = props;
    const [isExpanded, setisExpanded] = (0,react.useState)(true);
    const [general, setGeneral] = (0,react.useState)(null);
    const accordiumObject = (0,react.useRef)(null);
    const pageType = window.eventPageType;
    const handleAccordion = ()=>{
        setisExpanded(true);
    };
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then(function() {
            let config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            setGeneral(config === null || config === void 0 ? void 0 : config.general);
        });
    }, []);
    const CollapsibleHeader = (param)=>{
        let { title , open =false  } = param;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("h2", {
            className: "cmp-accordion__header",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "cmp-accordion__button ".concat(open ? "cmp-accordion__button--expanded" : ""),
                onClick: handleAccordion,
                "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"'.concat(componentPosition ? componentPosition : "accordion", '",\n        "internalLinkZoneName":"n/a","internalLinkURL":"n/a","internalLinkName":"').concat(title === null || title === void 0 ? void 0 : title.toLowerCase(), '",\n        "eventName":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(title === null || title === void 0 ? void 0 : title.toLowerCase(), '",\n        "internalLinkType":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(componentLinkType ? componentLinkType : "navigation", '",\n        "eventType":"accordion",\n        "eventAction":"').concat(pageType === null || pageType === void 0 ? void 0 : pageType.toLowerCase(), ":").concat(title === null || title === void 0 ? void 0 : title.toLowerCase(), '"}'),
                "aria-expanded": open,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        role: "heading",
                        "aria-level": "5",
                        className: "cmp-accordion__title",
                        children: title
                    }),
                    !isArrow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "cmp-accordion__icon",
                        "aria-hidden": true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "line line-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "line line-2"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "cmp-accordion__icon",
                        "aria-hidden": true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "down-arrow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: arrow_down/* default.src */.Z.src,
                                    alt: "Arrow Down"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "up-arrow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: arrow_up/* default.src */.Z.src,
                                    alt: "Arrow Up"
                                })
                            })
                        ]
                    })
                ]
            })
        });
    };
    const CollapsibleInnerText = (param)=>{
        let { gridColumnClassName , faqText , title  } = param;
        const finalText = (0,helper/* sanitizeInnerHtml */.KD0)((0,helper/* getShortenedUrlwithGeneral */.vu1)(faqText, general));
        const addFaqSeoScript = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: itemsOrder.map((item, i)=>({
                    "@type": "Question",
                    name: items[item]["cq:panelTitle"],
                    acceptedAnswer: {
                        "@type": "Answer",
                        text: items[item]["text"]
                    }
                }))
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "faq-script",
                    type: "application/ld+json",
                    children: JSON.stringify(addFaqSeoScript)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-accordian-title": title,
                    className: "cmp-accordion__panel".concat(isExpanded ? " cmp-accordion__panel--expanded" : " cmp-accordion__panel--hidden"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text ".concat(gridColumnClassName),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cmp-text",
                            children: finalText
                        })
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: id,
        ref: accordiumObject,
        className: "cmp-accordion",
        "data-placeholder-text": "false",
        children: itemsOrder === null || itemsOrder === void 0 ? void 0 : itemsOrder.map((item, i)=>{
            const title = items[item][titleKey];
            let gridColumnClassName = items[item]["appliedCssClassNames"];
            let faqText = items[item]["text"];
            if (!faqText) {
                faqText = "";
                const itemsOrderArr = items[item][":itemsOrder"];
                if (itemsOrderArr) {
                    itemsOrderArr.forEach((itemTx)=>{
                        faqText = "".concat(faqText).concat(items[item][":items"][itemTx]["text"]);
                        gridColumnClassName = "".concat(items[item][":items"][itemTx]["appliedCssClassNames"]);
                    });
                }
            }
            var ref;
            const isItemExpanded = (ref = expandedItems === null || expandedItems === void 0 ? void 0 : expandedItems.includes(item)) !== null && ref !== void 0 ? ref : isOpen;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-cmp-hook-accordion": "item",
                    className: "cmp-accordion__item",
                    id: "accordion-".concat(i, "-").concat((0,helper/* getRandom */.sZz)()),
                    "data-cmp-data-layer": '{"accordion-'.concat(i, "-").concat((0,helper/* getRandom */.sZz)(), '":{"@type":"kohler-us/components/accordion/item","dc:title":"').concat(title, '"}}'),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                        open: isItemExpanded,
                        onTriggerOpening: handleOpen,
                        onTriggerClosing: handleClose,
                        containerElementProps: containerElementProps,
                        overflowWhenOpen: contentOverflow ? contentOverflow : "hidden",
                        openedClassName: "collapsible--open",
                        tabIndex: "0",
                        triggerOpenedClassName: "collapsible__trigger--open",
                        trigger: trigger ? trigger : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleHeader, {
                            title: title
                        }),
                        triggerWhenOpen: trigger ? trigger : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleHeader, {
                            title: title,
                            open: true
                        }),
                        transitionTime: 400,
                        easing: "ease-in-out",
                        triggerElementProps: {
                            id: (0,utils/* accordionUniqueId */.M0)("collapsible-trigger", 9999, 1000)
                        },
                        contentElementId: (0,utils/* accordionUniqueId */.M0)("collapsible-content", 9999, 1000),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleInnerText, {
                            gridColumnClassName: gridColumnClassName,
                            faqText: faqText,
                            title: title
                        })
                    })
                })
            }, "accordion-".concat(i, "-").concat((0,helper/* getRandom */.sZz)()));
        })
    });
};
/* harmony default export */ var ProductAccordion_view = (Accordion);

;// CONCATENATED MODULE: ./components/ProductDetail/v3/ProductAccordion/index.jsx


const ProductAccordion = (props)=>{
    const { data: { accordionProperties ={} , componentLinkType =""  }  } = props;
    const { [":itemsOrder"]: itemsOrder , [":items"]: items , id  } = accordionProperties;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "accordion  ".concat(accordionProperties === null || accordionProperties === void 0 ? void 0 : accordionProperties.appliedCssClassNames, " productAccordionView"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductAccordion_view, {
            accordionProperties: accordionProperties,
            componentLinkType: componentLinkType,
            items: items,
            itemsOrder: itemsOrder,
            id: id,
            textKey: "text",
            titleKey: "cq:panelTitle"
        })
    });
};
/* harmony default export */ var v3_ProductAccordion = (ProductAccordion);


/***/ }),

/***/ 54365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51857);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24400);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_Default_BreadCrumb__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3282);
/* harmony import */ var _components_AemGrid__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89055);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81169);
/* harmony import */ var _components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10884);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(55760);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11763);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88751);
/* harmony import */ var _hooks_usePageAuth__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(48375);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(46201);
/* harmony import */ var _components_ProductList_v2_ProductList__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(18460);
/* harmony import */ var _store_features_productListSlice__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(49682);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(2595);
/* harmony import */ var _components_ProductList_v2_PLPLoader__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(80498);
/* harmony import */ var _components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(29472);
/* harmony import */ var _components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _components_ProductList_v2_ProductTile_index_module_scss__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(50702);
/* harmony import */ var _components_ProductList_v2_ProductTile_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_components_ProductList_v2_ProductTile_index_module_scss__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _components_Shared_UpsellInstallServices__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(61054);
/* harmony import */ var _components_ProductDetail_v3_ProductAccordion__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(30534);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_23__);



























/**
 * renders home page
 * @return {JSX.Element}
 * @param {object} props The props.
 */ const Listing = (props)=>{
    var ref;
    const { tmpData: data , headertmp: header , footertmp: footer , ip , adobeAnalytic , globalScript , footerScript , analyticsData , datalayerPageName , plpData , gbhDataLayerCustom , canonicalUrl ="" , seoPageScript ="" , breadCrumbApplicationJSonLd ="" , seoProperties , pageData , siteName , templateName =""  } = props;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("common");
    const language = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)();
    const { cartUrl  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_16__/* .selectCartState */ .xw);
    const [pageRedirect, setPageRedirect] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [seoScripts, setSeoScript] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const { redirectTarget: { page: { path =""  } = {}  } = {}  } = data;
    const { brandLogoImg , menu: { isOpen , mainCategoryActive , isRegionOpen , isAuthNavOpen  }  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_14__/* .selectGenericState */ .Px);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (ip) sessionStorage.setItem("true-ip", ip);
    }, [
        ip
    ]);
    (0,_hooks_usePageAuth__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)();
    const cartCount = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_13__/* .getCartCount */ .c0)();
    const ariaLabel = (0,_utils_cart__WEBPACK_IMPORTED_MODULE_13__/* .getAriaLabel */ .Xw)(t, cartCount);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_12__/* .getScriptsAndStyles */ .csL)(footer);
    }, [
        footer
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_12__/* .getAnalyticsScript */ .Szq)(adobeAnalytic);
    }, [
        adobeAnalytic
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_12__/* .getDataLayerObj */ .C2G)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (path) {
            setPageRedirect((0,_utils_helper__WEBPACK_IMPORTED_MODULE_12__/* .removeAndCleanLink */ .xEh)(path));
        }
    }, [
        path
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!isSsr && pageRedirect) {
            router.push(pageRedirect);
        }
    }, [
        isSsr,
        pageRedirect
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        // if (isSsr) return
        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_14__/* .setDatalayerPageName */ .dN)(datalayerPageName));
        dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_14__/* .setGbhDataLayerCustom */ .ks)(gbhDataLayerCustom));
        if (plpData) {
            dispatch((0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_18__/* .setPlpData */ .gS)({
                ...plpData,
                status: "succeeded",
                initialLoad: true
            }));
        }
        return ()=>{
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_14__/* .setDatalayerPageName */ .dN)(""));
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_14__/* .setGbhDataLayerCustom */ .ks)(""));
        };
    }, [
        datalayerPageName,
        gbhDataLayerCustom,
        plpData
    ]);
    const pageUrl = new URL(pageData === null || pageData === void 0 ? void 0 : pageData.pageUrl);
    var _origin;
    const originUrl = (_origin = pageUrl.origin) !== null && _origin !== void 0 ? _origin : "";
    const toggleMenu = ()=>{
        if (isOpen) {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_14__/* .closeMenu */ .Wj)());
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_14__/* .setAuthNav */ .AT)(false));
        } else {
            dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_14__/* .openMenu */ .qn)());
        }
    };
    const redirect = ()=>{
        router.push("".concat(cartUrl));
    };
    const eventHandler = {
        store: {
            brandLogoImg: brandLogoImg,
            isOpen,
            mainCategoryActive,
            isRegionOpen,
            isAuthNavOpen,
            cartCount,
            ariaLabel,
            cartUrl,
            plp: {
                ...plpData,
                status: "succeeded"
            }
        },
        callbacks: {
            setBrandLogoImg: (path)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_14__/* .setBrandLogoImg */ .XY)(path));
            },
            closeMenu: ()=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_14__/* .closeMenu */ .Wj)());
            },
            setMainCategory: (payload)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_14__/* .setActiveMainCategory */ .X7)(payload));
            },
            toggleMenu: ()=>{
                toggleMenu();
            },
            setRegionNav: (active)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_14__/* .setRegionNav */ .qX)(active));
            },
            setAuthNav: (active)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_14__/* .setAuthNav */ .AT)(active));
            },
            setGlobalScripts: (item)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_14__/* .setGlobalScripts */ .n8)(item));
            },
            setGlobalStyles: (item)=>{
                dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_14__/* .setGlobalStyles */ .cw)(item));
            },
            onClick: ()=>{
                redirect();
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (seoPageScript) {
            extractSeoPageScript(seoPageScript);
        }
    }, [
        seoPageScript
    ]);
    const extractSeoPageScript = function() {
        let scriptContent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        const scriptList = [];
        const doc = new DOMParser().parseFromString(scriptContent, "text/html");
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_12__/* .extractScriptsFromDOM */ .CZn)(doc, (item)=>scriptList.push(item));
        setSeoScript(scriptList);
    };
    var ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_6___default()), {
                children: [
                    canonicalUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: (language === null || language === void 0 ? void 0 : (ref = language.i18n) === null || ref === void 0 ? void 0 : ref.language) === "fr" ? canonicalUrl === null || canonicalUrl === void 0 ? void 0 : canonicalUrl.replace("/en/", "/fr/") : canonicalUrl
                    }) : null,
                    breadCrumbApplicationJSonLd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_23___default().sanitize(breadCrumbApplicationJSonLd)
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageHeader__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        header: header,
                        title: data.title,
                        globalScripting: globalScript,
                        fullUrl: canonicalUrl,
                        siteName: siteName,
                        phone: seoProperties === null || seoProperties === void 0 ? void 0 : seoProperties.phoneNum,
                        imageUrl: templateName === "category-landing-page" ? pageData === null || pageData === void 0 ? void 0 : pageData.thumbnailImageUrl : (ref1 = "".concat(originUrl, "/_next/static/media/BLOK_LOGO.00edf835.svg")) !== null && ref1 !== void 0 ? ref1 : "",
                        description: data === null || data === void 0 ? void 0 : data.description
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                        id: "4da4082d098430d2",
                        children: "@media print{@page{size:A4 portrait!important}}"
                    }),
                    seoScripts.map((script, i)=>!script.src && script.innerHTML ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_7___default()), {
                            id: "seoscript-".concat(i),
                            type: script.type,
                            "data-script-purpose": "seo",
                            children: "".concat(script.innerHTML)
                        }, "seoscript-".concat(i)) : null),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: data.id,
                        className: "jsx-4da4082d098430d2" + " " + (data.cssClassNames || ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AemGrid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            data: data,
                            count: 0,
                            eventHandler: eventHandler,
                            breadCrumb: (data, fullData)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Default_BreadCrumb__WEBPACK_IMPORTED_MODULE_8__["default"], {
                                    data: data,
                                    fullData: fullData,
                                    plpPage: true
                                }),
                            productAccordion: (data, fullData)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductDetail_v3_ProductAccordion__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                    data: data,
                                    fullData: fullData
                                }),
                            productList: (data, eventHandler)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_v2_ProductList__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    data: data,
                                    eventHandler: eventHandler
                                }),
                            productListFiller: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "jsx-4da4082d098430d2" + " " + "".concat((_components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().productListWrapper), " ").concat((_components_ProductList_v2_ProductTile_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().productTileWrapper)),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_v2_PLPLoader__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {})
                                }),
                            upSellContainer: (data)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_UpsellInstallServices__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    authData: data
                                })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_GlobalPage_GlobalPageFooter__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        footer: footer,
                        footerScripting: footerScript
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Listing);


/***/ }),

/***/ 25043:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ g; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var h = Object.defineProperty;
var u = (n, t, e) => t in n ? h(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var c = (n, t, e) => (u(n, typeof t != "symbol" ? t + "" : t, e), e);

const p = (n, t) => typeof getComputedStyle < "u" ? getComputedStyle(n, null).getPropertyValue(t) : n.style.getPropertyValue(t), y = (n) => p(n, "overflow") + p(n, "overflow-y") + p(n, "overflow-x"), w = (n) => {
  if (!(n instanceof HTMLElement))
    return window;
  let t = n;
  for (; t && !(t === document.body || t === document.documentElement || !t.parentNode); ) {
    if (/(scroll|auto)/.test(y(t)))
      return t;
    t = t.parentNode;
  }
  return window;
};
class g extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(e) {
    super(e);
    c(this, "elementObserver");
    c(this, "wrapper");
    c(this, "lazyLoadHandler", (e) => {
      var o, i;
      const {
        onContentVisible: s
      } = this.props, [r] = e, {
        isIntersecting: l
      } = r;
      if (l) {
        this.setState({
          visible: !0
        }, () => {
          s && s();
        });
        const a = (o = this.wrapper) == null ? void 0 : o.current;
        a && a instanceof HTMLElement && ((i = this.elementObserver) == null || i.unobserve(a));
      }
    });
    this.elementObserver = null, this.wrapper = react__WEBPACK_IMPORTED_MODULE_0__.createRef(), this.state = {
      visible: !1
    };
  }
  componentDidMount() {
    var o;
    this.getEventNode();
    const {
      offset: e,
      threshold: s
    } = this.props, r = {
      rootMargin: typeof e == "number" ? `${e}px` : e || "0px",
      threshold: s || 0
    };
    this.elementObserver = new IntersectionObserver(this.lazyLoadHandler, r);
    const l = (o = this.wrapper) == null ? void 0 : o.current;
    l instanceof HTMLElement && this.elementObserver.observe(l);
  }
  shouldComponentUpdate(e, s) {
    return s.visible;
  }
  componentWillUnmount() {
    var s, r;
    const e = (s = this.wrapper) == null ? void 0 : s.current;
    e && e instanceof HTMLElement && ((r = this.elementObserver) == null || r.unobserve(e));
  }
  getEventNode() {
    var e;
    return w((e = this.wrapper) == null ? void 0 : e.current);
  }
  render() {
    const {
      children: e,
      className: s,
      height: r,
      width: l,
      elementType: o
    } = this.props, {
      visible: i
    } = this.state, a = {
      height: r,
      width: l
    }, d = `LazyLoad${i ? " is-visible" : ""}${s ? ` ${s}` : ""}`;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(o || "div", {
      className: d,
      style: a,
      ref: this.wrapper
    }, i && react__WEBPACK_IMPORTED_MODULE_0__.Children.only(e));
  }
}
c(g, "defaultProps", {
  elementType: "div",
  className: "",
  offset: 0,
  threshold: 0,
  width: null,
  onContentVisible: null,
  height: null
});



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [361,3147,1054,1976,8787,8047,772,4417,7317,6828,5239,498,8460,9774,2888,179], function() { return __webpack_exec__(54906); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);